export var VERTEX_SHADER = 'vs';
export var FRAGMENT_SHADER = 'fs';
//# sourceMappingURL=constants.js.map


//////////////////
// WEBPACK FOOTER
// ./~/luma.gl/dist/esm/shadertools/src/lib/constants.js
// module id = 640
// module chunks = 0